/**
 * Logo Grid — accessible-slick carousel with true infinite loop.
 * Slick handles the cloning trick internally so the strip never visibly rewinds.
 * Advances one slide every 3s, pauses on hover/focus.
 */
(function ($) {
    'use strict';

    if (!$ || !$.fn || !$.fn.slick) return;

    function initCarousel(context) {
        var $root = context ? $(context) : $(document);
        var $carousels = $root.find('.logo-grid-carousel');

        $carousels.each(function () {
            var $carousel = $(this);
            if ($carousel.hasClass('slick-initialized')) return;

            var baseSlides = parseInt($carousel.attr('data-slides-to-show'), 10) || 6;

            $carousel.slick({
                infinite: true,
                slidesToShow: baseSlides,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 500,
                pauseOnHover: true,
                pauseOnFocus: true,
                arrows: false,
                dots: false,
                speed: 500,
                cssEase: 'linear',
                draggable: true,
                responsive: [
                    { breakpoint: 992, settings: { slidesToShow: baseSlides } },
                    { breakpoint: 768, settings: { slidesToShow: 4 } },
                    { breakpoint: 480, settings: { slidesToShow: 3 } },
                    { breakpoint: 1,   settings: { slidesToShow: 2 } }
                ]
            });
        });
    }

    // Front-end init
    $(function () { initCarousel(); });

    // ACF block-editor preview init
    if (window.acf) {
        var hookNames = [
            'render_block_preview/type=logo-grid',
            'render_block_preview/type=acf/logo-grid',
            'render_block_preview'
        ];

        hookNames.forEach(function (hookName) {
            window.acf.addAction(hookName, function ($block) {
                if ($block && $block[0] && $block[0].querySelector('.logo-grid-carousel')) {
                    setTimeout(function () { initCarousel($block[0]); }, 200);
                }
            });
        });
    }
})(window.jQuery);
